// Meta Pixel integration
declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1514363203367475'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    // Already initialized — just fire PageView again
    window.fbq('track', 'PageView')
    return
  }

  // Standard Meta Pixel bootstrap
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart(params?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', params || {})
}
